export const DOCS_URL = 'https://docs.mytrellis.io'

export function docsUrl(path: string): string {
  return `${DOCS_URL}${path}`
}
